import React, { Component } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import CountrySearch from "./RankCondition/CountrySearch";
import CategorySearch from './RankCondition/CategorySearch'
import ChannelSearch from './RankCondition/ChannelSearch'
import ScorllToTopButton from './RankCondition/ScorllToTopButton';
import LoadingSpinner from "../dev/LoadingSpinner";
class RankCondition extends Component {
    render() {
        const {
            messages,
            categoryValue,
            categoryContent,
            toggleCategory,
            channelTitleInputValue,
            channelTitleInput,
            channelTitleSubmit,
            resetCondition,
            country,
            countrySelect,
            isIpCountryLoading,
        } = this.props;
        return (
            <Container>
                <RankTitle>YouTube {messages.slide_ranking}</RankTitle>
                {isIpCountryLoading ? (
                    <LoadingSpinner justifyContentCenter minHeight="195px" />
                ) : (
                    <React.Fragment>
                        <ChannelSearch 
                            channelTitleInput={channelTitleInput}
                            channelTitleInputValue={channelTitleInputValue}
                            channelTitleSubmit={channelTitleSubmit}
                            resetCondition={resetCondition}
                            messages={messages}/>
                        <BottomFieldWrap>
                            <CountrySearch
                                country={country}
                                countrySelect={countrySelect}
                                text={`${messages.country}：`}
                            />
                            <CategorySearch 
                                categoryValue={categoryValue} 
                                categoryContent={categoryContent} 
                                toggleCategory={toggleCategory} 
                                messages={messages}/>
                        </BottomFieldWrap>
                    </React.Fragment>
                )}
                {window.matchMedia("(max-width: 665px)").matches && <ScorllToTopButton text={messages.back_to_top}/>}
            </Container>
        )
    }
}
const mapStateToProps = state => {
    return {
        messages: state.Messages
    };
};
export default connect(mapStateToProps)(RankCondition);
const Container = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    width: 900px;
    margin-top: 60px;
    background-color: #fff;
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.05);
    @media (max-width: 900px) {
        width: ${({ isMoibleConditionField }) =>
            isMoibleConditionField ? "100%" : "calc(100% - 40px)"};

        margin: ${({ isMoibleConditionField }) =>
            isMoibleConditionField ? "0" : "0 20px"};
    }
`;
const RankTitle = styled.div`
    position: absolute;
    display: flex;
    align-items: center;
    top: -28px;
    height: 28px;
    padding: 0 20px;
    border-radius: 16px 16px 0 0;
    background-color: #de0606;
    font-size: 20px;
    font-weight: 500;
    color: #fff;
`;
const BottomFieldWrap = styled.div`
    padding: 20px;
`;



// WEBPACK FOOTER //
// ./src/Ranking/RankCondition.js